import { useState } from 'react';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';

import api from '@/services/apiSgft';

import ModalConfirmation from '../molecules/ConfirmationModal';
import { ExtraTripsApprovalFlow } from '@/constants/tableColumns/ExtraTripsApprovalFlowsColumns';
import { BiEdit } from 'react-icons/bi';
import { BsTrashFill } from 'react-icons/bs';

interface Props {
	approvalFlow: ExtraTripsApprovalFlow;
	onEdit?: (approvalFlow: ExtraTripsApprovalFlow) => void;
	onDeactivate?: () => void;
}

const ApprovalFlowButtons = ({ approvalFlow, onEdit, onDeactivate }: Props) => {
	const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
	const queryClient = useQueryClient();

	const handleDeactivate = async () => {
		try {
			await api.put(`approval/flow/active/${approvalFlow.id}`, { active: false });
			toast.success('Fluxo de aprovação desativado com sucesso', {
				theme: 'colored',
				toastId: 'success',
			});
			setIsConfirmationModalOpen(false);
			queryClient.invalidateQueries(['extra-trips-approval-flows']);
			onDeactivate?.();
		} catch (e) {
			toast.error('Não foi possível desativar o fluxo de aprovação', {
				theme: 'colored',
				toastId: 'error',
			});
			setIsConfirmationModalOpen(false);
			throw e;
		}
	};

	const handleEdit = () => {
		onEdit?.(approvalFlow);
	};

	const handleCloseDeactivateModal = () => {
		setIsConfirmationModalOpen(false);
	};

	const handleOpenDeactivateModal = () => {
		setIsConfirmationModalOpen(true);
	};

	return (
		<div className="flex h-[35px] items-center justify-center space-x-3">
			<button
				type="button"
				onClick={handleEdit}
				title="Editar"
				className="disabled:opacity-35"
			>
				<BiEdit size={18} color="#193CB9" />
			</button>
			<button
				type="button"
				onClick={handleOpenDeactivateModal}
				title="Desativar"
				className="disabled:opacity-35"
			>
				<BsTrashFill size={18} color="#193CB9" />
			</button>
			<ModalConfirmation
				title="Confirmar desativação"
				description="Tem certeza que deseja desativar este fluxo de aprovação?"
				confirmAction={handleDeactivate}
				isOpen={isConfirmationModalOpen}
				onClose={handleCloseDeactivateModal}
				discartAction={handleCloseDeactivateModal}
			/>
		</div>
	);
};

export default ApprovalFlowButtons;

